export const Bulk = {
  path: '/bulk',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'bulk',
      component: () => import('pages/bulk/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.bulk.name',
        path: '/bulk',
      },
    },
  ],
};
